import { useEffect } from "react";
import GeneralConst from "@consts/GeneralConst";
import AppNavbar from "@components/AppNavbar/AppNavbar";
import TitleScreen from "@components/TitleScreen/TitleScreen";
import "./Homepage.scss";
import BeatStore from "@components/BeatStore/BeatStore";
import Pricing from "@components/Pricing/Pricing";
import AppFooter from "@components/AppFooter/AppFooter";
import YoutubeChannel from "@components/YoutubeChannel/YoutubeChannel";
import Contact from "@components/Contact/Contact";
import { Helmet } from "react-helmet";
import ArtistsBlade from "@components/ArtistsBlade/ArtistsBlade";
import GeneralService from "@services/GeneralService";
import FeatureFlags from "@config/feature-flags.json";

const TITLE = `Home | ${GeneralConst.SITE_NAME}`;

const Homepage = () => {
  useEffect(() => {
    void GeneralService.addSiteView(GeneralConst.DOMAIN_NAME);
  }, []);

  return (
    <div className="homepage">
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <AppNavbar />
      <TitleScreen />
      <BeatStore />
      <Pricing />
      {FeatureFlags.ARTISTS_BLADE && <ArtistsBlade />}
      <YoutubeChannel />
      <Contact />
      <AppFooter />
    </div>
  );
};

export default Homepage;
